/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { AttachmentMimeTypeFilter } from '../models';
// @ts-ignore
import type { ConversationCreatePayloadDTO } from '../models';
// @ts-ignore
import type { ConversationUpdatePayloadDTO } from '../models';
// @ts-ignore
import type { CountConversations200Response } from '../models';
// @ts-ignore
import type { CreateOperationConversation200Response } from '../models';
// @ts-ignore
import type { GetAttachmentsForConversation200Response } from '../models';
// @ts-ignore
import type { GetAttachmentsForConversationSortByParameter } from '../models';
// @ts-ignore
import type { GetConversationMembersAdmin200Response } from '../models';
// @ts-ignore
import type { GetGroupUsers200Response } from '../models';
// @ts-ignore
import type { GetMyConversations200Response } from '../models';
// @ts-ignore
import type { GetMyConversationsV3200Response } from '../models';
// @ts-ignore
import type { SearchGroupsAdmin200Response } from '../models';
// @ts-ignore
import type { SortOrder } from '../models';
/**
 * ConversationApi - axios parameter creator
 */
export const ConversationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary checkUserIsInConversation
         * @param {string} userId 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserIsInConversation: async (userId: string, conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('checkUserIsInConversation', 'userId', userId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('checkUserIsInConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/check-user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary countConversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countConversations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/conversation/admin/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createConversation
         * @param {ConversationCreatePayloadDTO} conversationCreatePayloadDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversation: async (conversationCreatePayloadDTO: ConversationCreatePayloadDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationCreatePayloadDTO' is not null or undefined
            assertParamExists('createConversation', 'conversationCreatePayloadDTO', conversationCreatePayloadDTO)
            const localVarPath = `/api/nora/chat/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationCreatePayloadDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('deleteConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAttachmentsForConversation
         * @param {string} conversationId 
         * @param {string} [query] 
         * @param {AttachmentMimeTypeFilter} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] Deprecated. Ignored; use skip for offset pagination.
         * @param {GetAttachmentsForConversationSortByParameter} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentsForConversation: async (conversationId: string, query?: string, filter?: AttachmentMimeTypeFilter, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: GetAttachmentsForConversationSortByParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getAttachmentsForConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/attachments`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getConversationMembers
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMembers: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationMembers', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/members`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getConversationMembersAdmin
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMembersAdmin: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationMembersAdmin', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/admin/members`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getConversationPermissions
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationPermissions: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationPermissions', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/permissions`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getConversationsByUserId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationsByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getConversationsByUserId', 'userId', userId)
            const localVarPath = `/api/nora/chat/conversation/admin/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getMyConversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConversations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/conversation/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getMyConversationsV3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConversationsV3: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/conversation/mine/v3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary markConversationAsRead
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConversationAsRead: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('markConversationAsRead', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/mark-as-read`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary markConversationAsUnread
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConversationAsUnread: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('markConversationAsUnread', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/mark-as-unread`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary muteConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('muteConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/mute`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary pinConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('pinConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/pin`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchConversationsAdmin
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsAdmin: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/conversation/admin/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchConversationsV2
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsV2: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/conversation/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary unMuteConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unMuteConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('unMuteConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/un-mute`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary unpinConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('unpinConversation', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/unpin`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateConversation
         * @param {string} conversationId 
         * @param {ConversationUpdatePayloadDTO} conversationUpdatePayloadDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversation: async (conversationId: string, conversationUpdatePayloadDTO: ConversationUpdatePayloadDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('updateConversation', 'conversationId', conversationId)
            // verify required parameter 'conversationUpdatePayloadDTO' is not null or undefined
            assertParamExists('updateConversation', 'conversationUpdatePayloadDTO', conversationUpdatePayloadDTO)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationUpdatePayloadDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationApi - functional programming interface
 */
export const ConversationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary checkUserIsInConversation
         * @param {string} userId 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUserIsInConversation(userId: string, conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOperationConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUserIsInConversation(userId, conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.checkUserIsInConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary countConversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countConversations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountConversations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countConversations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.countConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary createConversation
         * @param {ConversationCreatePayloadDTO} conversationCreatePayloadDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConversation(conversationCreatePayloadDTO: ConversationCreatePayloadDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOperationConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConversation(conversationCreatePayloadDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.createConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.deleteConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getAttachmentsForConversation
         * @param {string} conversationId 
         * @param {string} [query] 
         * @param {AttachmentMimeTypeFilter} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] Deprecated. Ignored; use skip for offset pagination.
         * @param {GetAttachmentsForConversationSortByParameter} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachmentsForConversation(conversationId: string, query?: string, filter?: AttachmentMimeTypeFilter, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: GetAttachmentsForConversationSortByParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAttachmentsForConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachmentsForConversation(conversationId, query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getAttachmentsForConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOperationConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getConversationMembers
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationMembers(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationMembers(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getConversationMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getConversationMembersAdmin
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationMembersAdmin(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConversationMembersAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationMembersAdmin(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getConversationMembersAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getConversationPermissions
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationPermissions(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroupUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationPermissions(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getConversationPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getConversationsByUserId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationsByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyConversationsV3200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationsByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getConversationsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getMyConversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyConversations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyConversations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyConversations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getMyConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getMyConversationsV3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyConversationsV3(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyConversationsV3200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyConversationsV3(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.getMyConversationsV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary markConversationAsRead
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markConversationAsRead(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markConversationAsRead(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.markConversationAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary markConversationAsUnread
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markConversationAsUnread(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markConversationAsUnread(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.markConversationAsUnread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary muteConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async muteConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.muteConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.muteConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary pinConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pinConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pinConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.pinConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchConversationsAdmin
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchConversationsAdmin(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchConversationsAdmin(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.searchConversationsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchConversationsV2
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchConversationsV2(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchConversationsV2(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.searchConversationsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary unMuteConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unMuteConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unMuteConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.unMuteConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary unpinConversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpinConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpinConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.unpinConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateConversation
         * @param {string} conversationId 
         * @param {ConversationUpdatePayloadDTO} conversationUpdatePayloadDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConversation(conversationId: string, conversationUpdatePayloadDTO: ConversationUpdatePayloadDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOperationConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConversation(conversationId, conversationUpdatePayloadDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationApi.updateConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversationApi - factory interface
 */
export const ConversationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationApiFp(configuration)
    return {
        /**
         * 
         * @summary checkUserIsInConversation
         * @param {ConversationApiCheckUserIsInConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserIsInConversation(requestParameters: ConversationApiCheckUserIsInConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOperationConversation200Response> {
            return localVarFp.checkUserIsInConversation(requestParameters.userId, requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary countConversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countConversations(options?: RawAxiosRequestConfig): AxiosPromise<CountConversations200Response> {
            return localVarFp.countConversations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createConversation
         * @param {ConversationApiCreateConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversation(requestParameters: ConversationApiCreateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOperationConversation200Response> {
            return localVarFp.createConversation(requestParameters.conversationCreatePayloadDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteConversation
         * @param {ConversationApiDeleteConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversation(requestParameters: ConversationApiDeleteConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAttachmentsForConversation
         * @param {ConversationApiGetAttachmentsForConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentsForConversation(requestParameters: ConversationApiGetAttachmentsForConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAttachmentsForConversation200Response> {
            return localVarFp.getAttachmentsForConversation(requestParameters.conversationId, requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getConversation
         * @param {ConversationApiGetConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(requestParameters: ConversationApiGetConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOperationConversation200Response> {
            return localVarFp.getConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getConversationMembers
         * @param {ConversationApiGetConversationMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMembers(requestParameters: ConversationApiGetConversationMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.getConversationMembers(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getConversationMembersAdmin
         * @param {ConversationApiGetConversationMembersAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMembersAdmin(requestParameters: ConversationApiGetConversationMembersAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetConversationMembersAdmin200Response> {
            return localVarFp.getConversationMembersAdmin(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getConversationPermissions
         * @param {ConversationApiGetConversationPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationPermissions(requestParameters: ConversationApiGetConversationPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetGroupUsers200Response> {
            return localVarFp.getConversationPermissions(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getConversationsByUserId
         * @param {ConversationApiGetConversationsByUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationsByUserId(requestParameters: ConversationApiGetConversationsByUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMyConversationsV3200Response> {
            return localVarFp.getConversationsByUserId(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getMyConversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConversations(options?: RawAxiosRequestConfig): AxiosPromise<GetMyConversations200Response> {
            return localVarFp.getMyConversations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getMyConversationsV3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConversationsV3(options?: RawAxiosRequestConfig): AxiosPromise<GetMyConversationsV3200Response> {
            return localVarFp.getMyConversationsV3(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary markConversationAsRead
         * @param {ConversationApiMarkConversationAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConversationAsRead(requestParameters: ConversationApiMarkConversationAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.markConversationAsRead(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary markConversationAsUnread
         * @param {ConversationApiMarkConversationAsUnreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConversationAsUnread(requestParameters: ConversationApiMarkConversationAsUnreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.markConversationAsUnread(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary muteConversation
         * @param {ConversationApiMuteConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteConversation(requestParameters: ConversationApiMuteConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.muteConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary pinConversation
         * @param {ConversationApiPinConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinConversation(requestParameters: ConversationApiPinConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.pinConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchConversationsAdmin
         * @param {ConversationApiSearchConversationsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsAdmin(requestParameters: ConversationApiSearchConversationsAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchConversationsAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchConversationsV2
         * @param {ConversationApiSearchConversationsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsV2(requestParameters: ConversationApiSearchConversationsV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchConversationsV2(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary unMuteConversation
         * @param {ConversationApiUnMuteConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unMuteConversation(requestParameters: ConversationApiUnMuteConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.unMuteConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary unpinConversation
         * @param {ConversationApiUnpinConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinConversation(requestParameters: ConversationApiUnpinConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.unpinConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateConversation
         * @param {ConversationApiUpdateConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversation(requestParameters: ConversationApiUpdateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOperationConversation200Response> {
            return localVarFp.updateConversation(requestParameters.conversationId, requestParameters.conversationUpdatePayloadDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkUserIsInConversation operation in ConversationApi.
 */
export interface ConversationApiCheckUserIsInConversationRequest {
    readonly userId: string

    readonly conversationId: string
}

/**
 * Request parameters for createConversation operation in ConversationApi.
 */
export interface ConversationApiCreateConversationRequest {
    readonly conversationCreatePayloadDTO: ConversationCreatePayloadDTO
}

/**
 * Request parameters for deleteConversation operation in ConversationApi.
 */
export interface ConversationApiDeleteConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for getAttachmentsForConversation operation in ConversationApi.
 */
export interface ConversationApiGetAttachmentsForConversationRequest {
    readonly conversationId: string

    readonly query?: string

    readonly filter?: AttachmentMimeTypeFilter

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    /**
     * Deprecated. Ignored; use skip for offset pagination.
     */
    readonly cursor?: string

    readonly sortBy?: GetAttachmentsForConversationSortByParameter
}

/**
 * Request parameters for getConversation operation in ConversationApi.
 */
export interface ConversationApiGetConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for getConversationMembers operation in ConversationApi.
 */
export interface ConversationApiGetConversationMembersRequest {
    readonly conversationId: string
}

/**
 * Request parameters for getConversationMembersAdmin operation in ConversationApi.
 */
export interface ConversationApiGetConversationMembersAdminRequest {
    readonly conversationId: string
}

/**
 * Request parameters for getConversationPermissions operation in ConversationApi.
 */
export interface ConversationApiGetConversationPermissionsRequest {
    readonly conversationId: string
}

/**
 * Request parameters for getConversationsByUserId operation in ConversationApi.
 */
export interface ConversationApiGetConversationsByUserIdRequest {
    readonly userId: string
}

/**
 * Request parameters for markConversationAsRead operation in ConversationApi.
 */
export interface ConversationApiMarkConversationAsReadRequest {
    readonly conversationId: string
}

/**
 * Request parameters for markConversationAsUnread operation in ConversationApi.
 */
export interface ConversationApiMarkConversationAsUnreadRequest {
    readonly conversationId: string
}

/**
 * Request parameters for muteConversation operation in ConversationApi.
 */
export interface ConversationApiMuteConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for pinConversation operation in ConversationApi.
 */
export interface ConversationApiPinConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for searchConversationsAdmin operation in ConversationApi.
 */
export interface ConversationApiSearchConversationsAdminRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for searchConversationsV2 operation in ConversationApi.
 */
export interface ConversationApiSearchConversationsV2Request {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for unMuteConversation operation in ConversationApi.
 */
export interface ConversationApiUnMuteConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for unpinConversation operation in ConversationApi.
 */
export interface ConversationApiUnpinConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for updateConversation operation in ConversationApi.
 */
export interface ConversationApiUpdateConversationRequest {
    readonly conversationId: string

    readonly conversationUpdatePayloadDTO: ConversationUpdatePayloadDTO
}

/**
 * ConversationApi - object-oriented interface
 */
export class ConversationApi extends BaseAPI {
    /**
     * 
     * @summary checkUserIsInConversation
     * @param {ConversationApiCheckUserIsInConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkUserIsInConversation(requestParameters: ConversationApiCheckUserIsInConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).checkUserIsInConversation(requestParameters.userId, requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary countConversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countConversations(options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).countConversations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createConversation
     * @param {ConversationApiCreateConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createConversation(requestParameters: ConversationApiCreateConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).createConversation(requestParameters.conversationCreatePayloadDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteConversation
     * @param {ConversationApiDeleteConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConversation(requestParameters: ConversationApiDeleteConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).deleteConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAttachmentsForConversation
     * @param {ConversationApiGetAttachmentsForConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAttachmentsForConversation(requestParameters: ConversationApiGetAttachmentsForConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getAttachmentsForConversation(requestParameters.conversationId, requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getConversation
     * @param {ConversationApiGetConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversation(requestParameters: ConversationApiGetConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getConversationMembers
     * @param {ConversationApiGetConversationMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversationMembers(requestParameters: ConversationApiGetConversationMembersRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getConversationMembers(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getConversationMembersAdmin
     * @param {ConversationApiGetConversationMembersAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversationMembersAdmin(requestParameters: ConversationApiGetConversationMembersAdminRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getConversationMembersAdmin(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getConversationPermissions
     * @param {ConversationApiGetConversationPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversationPermissions(requestParameters: ConversationApiGetConversationPermissionsRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getConversationPermissions(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getConversationsByUserId
     * @param {ConversationApiGetConversationsByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversationsByUserId(requestParameters: ConversationApiGetConversationsByUserIdRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getConversationsByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getMyConversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMyConversations(options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getMyConversations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getMyConversationsV3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMyConversationsV3(options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).getMyConversationsV3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary markConversationAsRead
     * @param {ConversationApiMarkConversationAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markConversationAsRead(requestParameters: ConversationApiMarkConversationAsReadRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).markConversationAsRead(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary markConversationAsUnread
     * @param {ConversationApiMarkConversationAsUnreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markConversationAsUnread(requestParameters: ConversationApiMarkConversationAsUnreadRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).markConversationAsUnread(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary muteConversation
     * @param {ConversationApiMuteConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public muteConversation(requestParameters: ConversationApiMuteConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).muteConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary pinConversation
     * @param {ConversationApiPinConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pinConversation(requestParameters: ConversationApiPinConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).pinConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchConversationsAdmin
     * @param {ConversationApiSearchConversationsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchConversationsAdmin(requestParameters: ConversationApiSearchConversationsAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).searchConversationsAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchConversationsV2
     * @param {ConversationApiSearchConversationsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchConversationsV2(requestParameters: ConversationApiSearchConversationsV2Request = {}, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).searchConversationsV2(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary unMuteConversation
     * @param {ConversationApiUnMuteConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unMuteConversation(requestParameters: ConversationApiUnMuteConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).unMuteConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary unpinConversation
     * @param {ConversationApiUnpinConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unpinConversation(requestParameters: ConversationApiUnpinConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).unpinConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateConversation
     * @param {ConversationApiUpdateConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConversation(requestParameters: ConversationApiUpdateConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationApiFp(this.configuration).updateConversation(requestParameters.conversationId, requestParameters.conversationUpdatePayloadDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

